import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AccessUserInfo, LabActionItemTabDetail, UserLocationFacility, redrawLabItems } from 'src/app/models';
import { UserAction } from 'src/app/enum/user/userActions';
import { CustomDialogService } from 'src/app/services/utility/custom-dialog.service';
import { LabActionItemService } from 'src/app/services/water-lab/lab-action-item.service';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { LoaderService } from 'src/app/services/loader.service';
import { CustomDatePipe } from 'src/app/pipes';
import { PreviewLabelComponent } from '../../request/preview-label/preview-label.component';
import { WorkFlow } from 'src/app/enum/water-lab/workFlow';

import {  SelectItem } from 'primeng';
import { DialogService } from 'primeng/dynamicdialog';
import { UserService } from 'src/app/services';


@Component({
  selector: 'bart-redraw-labs',
  templateUrl: './redraw-labs.component.html',
  styleUrls: ['./redraw-labs.component.scss'],
  providers:[CustomDatePipe, DialogService, CustomDialogService]
})
export class RedrawLabsComponent implements OnInit {
  @Input() selectedFacilityMasterId : number;
  @Input() userFacilities :UserLocationFacility [];
  @Input() tabDetails:LabActionItemTabDetail
  userDetail: any = null;
  redrawActionItems: redrawLabItems[];
  cols: any[];
  facilityDisplayName:string;
  @Output() refreshTabCount: EventEmitter<any> = new EventEmitter();
  constructor(
    public dialogService: CustomDialogService,
    private _labActionItemService:LabActionItemService,
    private _loaderService:LoaderService,
    private _datePipe: CustomDatePipe,
    private _userService: UserService) { 
    this.userDetail = AccessUserInfo.getUserInfo();
    
  }

  ngOnInit() {
    this.cols = [
      { field: 'LabRequisitionNumber', header: 'Requisition ID' ,display: 'table-cell',width: "10%" }, 
      { field: 'EquipmentDisplayName', header: 'Model # | Nickname | Serial # | Equipment ID',display: 'table-cell', width: "22%" },
      { field: 'RedrawNotificationDate', header: 'Redraw Notification Date' ,display: 'table-cell',width: "15%" },
      { field: 'RedrawReason', header: 'Redraw Reason' ,display: 'table-cell',width: "15%" },
      { field: 'Result', header: 'Result | Unit' ,display: 'table-cell',width: "13%" },
      { field: 'ShippingManifestDate', header: 'Shipping Manifest Date' ,display: 'table-cell',width: "15%" }
    ];
    this.getRedrawActionItems();
    //#region User Action Audit
   this._userService.logUserAction({
    userName: this.userDetail.userName,
    userAction: UserAction.FILTER,
    screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
    screenPath: location.pathname,
    key: "FacilityMasterID",
    value: this.selectedFacilityMasterId,
    eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_REDRAW_GRID_LOADED
  });
  //#endregion
  };
  getRedrawActionItems(){
        this._loaderService.show()
        let getNoLabRequestActionItemsParams = {
          GETREDRAWACTIONITEMS: {
            FacilityMasterID: this.selectedFacilityMasterId
          },
        }
        this._labActionItemService.getRedrawActionItems(JSON.stringify(getNoLabRequestActionItemsParams)).subscribe(data => {
          this.redrawActionItems = data.GetRedrawActionItems;
          this.redrawActionItems.forEach(element => {
            element.ShippingManifestDate = this._datePipe.transform( element.ShippingManifestDate,"local","MM/dd/yyyy HH:mm"),
            element.ShippingManifestDateSort = this._datePipe.transform( element.ShippingManifestDate,"local","MM/dd/yyyy HH:mm"),
            element.RedrawNotificationDate = this._datePipe.transform( element.RedrawNotificationDate,"local","MM/dd/yyyy HH:mm"),
            element.RedrawNotificationDateSort = this._datePipe.transform( element.RedrawNotificationDate,"local","MM/dd/yyyy HH:mm")
        });
        if(this.redrawActionItems && this.tabDetails.RecordCount!=this.redrawActionItems.length)
        {
          this.tabDetails.RecordCount=this.redrawActionItems.length
        }
        this._loaderService.hide()
       
      },
        err => {
          this._loaderService.hide()
        });

  }

  redrawLabRequisition(rowData:any)
  {
    const ref = this.dialogService.open(PreviewLabelComponent, {
      header: WorkFlow.HOME==rowData.WorkFlow?'Home Label Summary':'Label Summary',
      styleClass:"preview-label-summary-popup",
      data:
      {
        labRequisitionId:rowData.LabRequisitionID,
        labRequestId:rowData.LabRequestID,
        facilityMasterId:this.selectedFacilityMasterId,
        facilityDisplayName:this.facilityDisplayName=this.userFacilities.find(x=>x.FacilityMasterID==this.selectedFacilityMasterId).FacilityDisplayName,
        workFlow:rowData.WorkFlow,
        selectedRows:rowData,
        isReDraw:true
      }
    });
    ref.onClose.subscribe(ref => {
      this.refreshTabCount.emit();  
    });

    //#region User Action Audit
   this._userService.logUserAction({
    userName: this.userDetail.userName,
    userAction: UserAction.BUTTON_CLICKED,
    screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
    screenPath: location.pathname,
    key: "labRequisitionId",
    value: rowData.LabRequisitionID,
    eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_REDRAW_GRID_REDRAW_CLICKED
  });
  //#endregion

  
  }
  sortColumn(event) {
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userDetail.userName,
      userAction: UserAction.SORT,
      screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
      screenPath: location.pathname,
      key: event.field,
      value: event.order === 1 ? 'ASC' : 'DESC',
      eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_REDRAW_COLUMN_SORT
    });
    //#endregion
  }
paginate(event) {
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userDetail.userName,
      userAction: UserAction.PAGE_CHANGED,
      screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
      screenPath: location.pathname,
      key: 'Selected_Page_No',
      value: (event.first / event.rows) + 1,
      eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_REDRAW_PAGE_NO_CLICKED
    });
    //#endregion
  }


}
